import { Column } from "@ag-grid-community/core";
import { AgGridReact } from "@ag-grid-community/react";
import { BooleanTableCellValue } from "gen/model/booleanTableCellValue";
import { GenericTableCell } from "gen/model/genericTableCell";
import { GenericTableColumn } from "gen/model/genericTableColumn";
import { GenericTableRow } from "gen/model/genericTableRow";
import { first } from "lodash-es";
import { DataTableContext } from "shared/components/table/data/DataTableContext";
import {
  DataTableAgHeaderComponentParams,
  GetColumnDefFn,
} from "shared/components/table/data/DataTableTypes";
import { COLUMN_ID_AUTO_COLUMN } from "shared/components/table/data/internal/DataTableConstants";

export const moneyCellValue = (cell: GenericTableCell | null | undefined) =>
  cell?.value?.type === "money" ? cell.value.amount : null;

export const decimalCellValue = (cell: GenericTableCell | null | undefined) =>
  cell?.value?.type === "decimal" ? cell.value.value : null;

export const textCellValue = (cell: GenericTableCell | null | undefined) =>
  cell?.value?.type === "text" ? cell.value.text : null;

export const getDataTableAgHeaderComponentParams = (
  agColumn: Column,
): DataTableAgHeaderComponentParams =>
  agColumn.getColDef()
    .headerComponentParams as DataTableAgHeaderComponentParams;

export const getRootGenericTableColumFromAgColumn = (
  agColumn: Column | undefined | null,
): GenericTableColumn | undefined => {
  if (!agColumn) {
    return undefined;
  }
  const { parentColumns } = getDataTableAgHeaderComponentParams(agColumn);
  return first(parentColumns);
};

export const isAutoGroupColumn = (agColumn: Column): boolean =>
  agColumn.getColId() === COLUMN_ID_AUTO_COLUMN;

export const dataTableContextFromAgGrid = (
  agGrid: AgGridReact | undefined | null,
): DataTableContext | undefined => {
  const context = agGrid?.props.context;
  if (!context || !("tableData" in context)) {
    return undefined;
  }
  return context as DataTableContext;
};

//  will get the rowSelectionState value for the rowSelection prop on the DataTable when using selectable children rows.
export const getSelectedChildrenRows = (
  rows: GenericTableRow[],
): Record<string, boolean> =>
  rows
    .map((row) =>
      row.child_rows?.reduce(
        (r, child_row) => ({
          ...r,
          [child_row.id]: (
            child_row.cells.is_selected.value as BooleanTableCellValue
          ).value,
        }),
        {},
      ),
    )
    .reduce<Record<string, boolean>>(
      (r, selected_kv_per_row) => ({ ...r, ...selected_kv_per_row }),
      {},
    );

export const suppressAutoSizePinnedColumns: GetColumnDefFn = ({ column }) => {
  if (column.is_pinned) {
    return {
      suppressAutoSize: true,
      initialWidth: 200,
    };
  }
};
